import type { TabCategory } from "@/types";
import { Tabs } from "@mantine/core";
import Tab from "./Tab";

interface Props {
    tabs: TabCategory[];
    activeTab: string | null;
}
export default function TabList({ tabs, activeTab }: Props) {
    return (
        <>
            <Tabs.List className="items-center flex justify-center">
                {tabs.map((tab: TabCategory) => (
                    <div key={tab.value}>
                        <Tab
                            value={tab.value}
                            text={tab.text}
                            numberOfVideos={tab.numberOfVideos}
                            icon={tab.icon}
                            activeTab={activeTab}
                        />
                    </div>
                ))}
            </Tabs.List>
        </>
    );
}
